import React from 'react';
import { Star } from 'lucide-react';

const OutletSection = () => {
  return (
    <section className="relative py-14 sm:py-16 paper-texture" data-testid="outlet-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Star size={10} fill="#EE2535" stroke="none" />
          <span className="font-mono text-xs font-bold tracking-[0.2em] uppercase" style={{ color: '#EE2535' }}>
            NOW OPEN IN HYDERABAD
          </span>
          <Star size={10} fill="#EE2535" stroke="none" />
        </div>

        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl mb-5" style={{ color: '#1A1918' }} data-testid="outlet-title">
          WELCOME TO CASA LOCO INDIA
        </h2>

        <div className="space-y-4 font-mono text-[#4A4641] text-sm leading-relaxed">
          <p>
            <span className="font-bold" style={{ color: '#EE2535' }}>We are Casa Loco</span> — and our journey to bring authentic Mexican food to India is a story of passion, flavor, and fiesta! Born in the coastal regions of Vietnam, we've built three thriving outlets across Da Nang, Hoi An, and An Bang.
          </p>
          <p>
            Now, we've brought our vibrant fiesta to Hyderabad! Partnering with Isthara, we chose India's most dynamic city for our debut — bringing genuine Mexican recipes, Lucha Libre-themed decor, and the spirit of a true Mexican cantina to Gachibowli.
          </p>
          <p style={{ color: '#51A262', fontWeight: 700 }}>
            Authentic Mexican, Sized and Spiced for India.
          </p>
        </div>

        <a
          href="/about"
          className="inline-block mt-6 px-6 py-3 font-display tracking-wider text-base transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
          data-testid="outlet-about-btn"
          style={{ backgroundColor: '#51A262', color: 'white', border: '3px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}
        >
          OUR STORY
        </a>
      </div>
    </section>
  );
};

export default OutletSection;
